import { useGetManyReference, useGetOne } from "react-admin";
import { FieldValues, Path } from "react-hook-form";
import { SelectInput } from "./SelectInput";
import { SxProps } from "@mui/material";
import { useAutovioContext } from "../hooks/useAutovioContext";
import { useMemo } from "react";
import { Room } from "../providers/roomsProvider";
import { Branch } from "../providers/branchesProvider";

interface RoomInputProps {
  source: Path<FieldValues>;
  branchId?: string;
  bulkEdit?: boolean;
  fullWidth?: boolean;
  size?: "small";
  helperText?: string;
  sx?: SxProps;
}

export const RoomInput = (props: RoomInputProps) => {
  const { branchId, ...rest } = props;
  const [{ drivingSchoolId }] = useAutovioContext();
  const { data: rooms } = useGetManyReference<Room>("rooms", {
    target: "drivingSchoolId",
    id: drivingSchoolId,
    ...(branchId ? { filter: { branchId } } : {}),
    sort: { field: "name", order: "ASC" },
    pagination: { page: 1, perPage: 999 },
  });
  const { data: branch } = useGetOne<Branch>("branches", { id: branchId! }, { enabled: !!branchId });
  const options = useMemo((): Array<[string, string]> => {
    if (!rooms) {
      return [];
    }
    return [["", ""], ...rooms.map((room): [string, string] => [room.id, room.name])];
  }, [rooms]);
  return (
    <SelectInput
      label="Raum"
      options={options}
      {...rest}
      warning={
        options.length === 1 &&
        (branchId
          ? `Es wurde noch kein Raum für die ${branch ? `Filiale ${branch.name}` : "gewählte Filiale"} angelegt.`
          : "Es wurde noch kein Raum angelegt.")
      }
    />
  );
};
